<template >
  <!-- eslint-disable max-len dark-->
  <v-toolbar
    id="headbar"
    v-bind:color="toolbarColor"
    app
    flat
    fixed
    v-if="!isUiMinimized && isBottomBtnShow"
    v-on="toolbarClickHandler"
    v-bind:dense="this.$store.state.isRunningEmbedded && !isUiMinimized"
    v-bind:class="{ minimized: isUiMinimized }"
    aria-label="Toolbar with sound FX mute button, minimise chat window button and option chat back a step button"
  >
    <div v-on:click="returnTop()">
      <!-- <v-icon>
          menu
        </v-icon> -->
      <img
        style="display: flex"
        :src="require('@/assets/arrow-left@2x.png')"
        width="30vw"
        height="30vw"
      />

      <!-- <v-text style="background-color: red">111</v-text> -->
    </div>

    <!-- eslint-enable max-len -->
    <!-- <img
      v-if="toolbarLogo"
      v-bind:src="toolbarLogo"
      alt="logo"
      aria-hidden="true"
    /> -->

    <!--      fab   small  aria-label="menu options"   class="menu"    v-show="!isUiMinimized"  v-on="tooltipMenuEventHandlers" -->
    <v-menu v-if="showToolbarMenu" offset-y>
      <!-- <v-btn slot="activator" v-on:click="returnTop()" icon dark> -->
      <!-- <v-icon>
          menu
        </v-icon> -->
      <!-- <img
          :src="require('@/assets/arrow@2x.png')"
          width="20vw"
          height="20vw"
        /> -->
      <!-- <v-text style="background-color: red">111</v-text> -->
      <!-- </v-btn> -->
      <!-- <v-btn
        slot="activator"
        v-show="!isUiMinimized"
        v-on="tooltipMenuEventHandlers"
        class="menu"
        icon
        fab
        small
        aria-label="menu options"
      >
        <v-icon> menu </v-icon>
      </v-btn> -->
      <v-list>
        <v-list-tile v-if="isForceLogin">
          <v-list-tile-title
            v-if="isLoggedIn"
            v-on:click="requestLogout"
            aria-label="logout"
          >
            <v-icon>
              {{ items[1].icon }}
            </v-icon>
            {{ items[1].title }}
          </v-list-tile-title>
          <v-list-tile-title
            v-if="!isLoggedIn"
            v-on:click="requestLogin"
            aria-label="login"
          >
            <v-icon>
              {{ items[0].icon }}
            </v-icon>
            {{ items[0].title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title
            v-on:click="requestResetHistory"
            aria-label="clear chat history"
          >
            <v-icon>
              {{ items[2].icon }}
            </v-icon>
            {{ items[2].title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="shouldRenderSfxButton && isSFXOn">
          <v-list-tile-title
            v-on:click="toggleSFXMute"
            aria-label="mute sound effects"
          >
            <v-icon>
              {{ items[3].icon }}
            </v-icon>
            {{ items[3].title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="shouldRenderSfxButton && !isSFXOn">
          <v-list-tile-title
            v-on:click="toggleSFXMute"
            aria-label="unmute sound effects"
          >
            <v-icon>
              {{ items[4].icon }}
            </v-icon>
            {{ items[4].title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title
            v-on:click="requestLiveChat"
            aria-label="request live chat"
          >
            <v-icon>
              {{ items[5].icon }}
            </v-icon>
            {{ items[5].title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title
            v-on:click="endLiveChat"
            aria-label="end live chat"
          >
            <v-icon>
              {{ items[6].icon }}
            </v-icon>
            {{ items[6].title }}
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile
          v-for="locale in locales"
          v-bind:key="locale"
          :disabled="restrictLocaleChanges"
        >
          <v-list-tile-title v-on:click="setLocale(locale)">
            {{ locale }}
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>

    <div class="nav-buttons">
      <!-- <v-btn
        small
        icon
        :disabled="isLexProcessing"
        class="nav-button-prev"
        v-on="prevNavEventHandlers"
        v-on:click="onPrev"
        v-show="hasPrevUtterance && !isUiMinimized && shouldRenderBackButton"
        aria-label="go back to previous message"
      >
        <v-icon> arrow_back </v-icon>
      </v-btn> -->
      <v-tooltip
        v-model="prevNav"
        activator=".nav-button-prev"
        content-class="tooltip-custom"
        right
      >
        <span>Previous</span>
      </v-tooltip>
    </div>

    <v-toolbar-title
      class="hidden-xs-and-down"
      v-on:click.stop="toggleMinimize"
      v-show="!isUiMinimized"
      :style="{ display: 'flex' }"
    >
      <!-- position: 'fixed'  :style="{ width: '-webkit-fill-available' }" <h1>{{ toolbarTitle }}</h1> -->
      <!-- <Lottie
        :options="defaultOptions"
        :height="30"
        :width="30"
        :style="{
          opacity:
            this.animate || this.$store.state.messages.length > 1 || this.Focus
              ? 100
              : 100,
        }"
      /> alt="logo"
      aria-hidden="true"-->
      <img
        v-if="toolbarLogo"
        v-bind:src="toolbarLogo"
        :style="{
          width: '7vw',
          height: '7vw',
        }"
      />
      <!-- <img
        :src="require('@/assets/title@2x.png')"
        :style="{
          width: '7vw',
          height: '7vw',
        }"
      /> -->
      <div
        style="
          margin-left: 1.5vw;
          color: #333333;
          fontsize: 1.3rem;
          font-weight: 700;
          margin-top: 1vw;
          font-size: 5vw;
        "
        v-on:click="onClickTitle"
      >
        {{ $t("licence.Robot_title_Beta") }}
      </div>
    </v-toolbar-title>
    <v-toolbar-title class="hidden-xs-and-down" v-show="!isUiMinimized">
      {{ userName }}
    </v-toolbar-title>

    <v-spacer />
    <!-- tooltip should be before btn to avoid right margin issue in mobile -->
    <v-tooltip
      v-model="shouldShowTooltip"
      content-class="tooltip-custom"
      activator=".min-max-toggle"
      left
    >
      <span id="min-max-tooltip">{{ toolTipMinimize }}</span>
    </v-tooltip>
    <v-tooltip
      v-model="shouldShowHelpTooltip"
      content-class="tooltip-custom"
      activator=".help-toggle"
      left
    >
      <span id="help-tooltip">help</span>
    </v-tooltip>
    <v-tooltip
      v-model="shouldShowMenuTooltip"
      content-class="tooltip-custom"
      activator=".menu"
      right
    >
      <span id="menu-tooltip">menu</span>
    </v-tooltip>
    <!-- v-on="tooltipHelpEventHandlers" <span v-if="isLocaleSelectable" class="localeInfo">{{currentLocale}}</span>    v-on:click="sendHelp"-->

    <!-- <v-btn
      v-if="shouldRenderHelpButton && !isUiMinimized"
      v-on:click="sendHelp"
      v-bind:disabled="isLexProcessing"
      icon
      dark
      class="help-toggle"
    >
      <v-icon> help_outline </v-icon> -->
    <div v-on:click="sendHelp">
      <img v-bind:src="icondotsLogo" width="28vw" height="28vw" :style="{}" />
    </div>
    <!-- <img

      v-bind:src="icondotsLogo"
       :style="{
          width: '30vw',
          height: '30vw',
        }"
    /> -->
    <!-- </v-btn> -->

    <v-dialog v-model="sheet">
      <v-card :style="{ 'border-radius': '15px' }">
        <v-card-title class="titleText" style="padding-bottom: 0">
          {{ $t("licence.key_delete_confirmation") }}</v-card-title
        >
        <v-card-title class="text-h5">
          {{ $t("licence.key_delete_popup") }}
        </v-card-title>
        <v-divider
          :style="{
            backgroundColor: '#eeeeee',
          }"
        ></v-divider>
        <!-- <v-card-text>Let Google help apps determine location. This means sending anonymous location data to Google, even when no apps are running.</v-card-text> -->
        <v-card-actions
          :style="{ 'justify-content': 'space-around', padding: '15px' }"
        >
          <div
            style="
              display: flex;
              width: -webkit-fill-available;
              justify-content: space-evenly;
            "
          >
            <div
              white
              text
              @click="sheet = dialog = false"
              style="font-size: 4.5vw; font-weight: bold"
            >
              {{ $t("licence.key_cancel") }}
            </div>
            <div style="color: #eeee; width: 1vw">|</div>
            <div
              text
              @click="requestResetHistory"
              :style="{
                color: '#0A79C3',
                fontSize: '4.5vw',
                'font-weight': 'bold',
              }"
            >
              {{ $t("licence.key_confirm") }}
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-btn
      v-if="$store.state.isRunningEmbedded"
      v-on:click.stop="toggleMinimize"
      v-on="tooltipEventHandlers"
      class="min-max-toggle"
      icon
      v-bind:aria-label="isUiMinimized ? 'chat' : 'minimize chat window toggle'"
    >
      <v-icon>
        {{ isUiMinimized ? "chat" : "arrow_drop_down" }}
      </v-icon>
    </v-btn>

    <!-- <div class="test"> v-sheet-->
    <v-bottom-sheet v-model="dialog">
      <div class="bottomsheet">
        <div class="text-center" height="200px">
          <!-- <v-btn
          class="mt-6"
          text
          color="red"
          @click="sheet = true"
        >
          close
        </v-btn> -->

          <div class="py-3" @click="sheet = true">
            <!-- <div class="border-top" ></div> -->
            <v-divider
              inset
              :style="{
                width: '46px',
                height: '4px',
                'border-radius': '3px',
                marginLeft: '43vw',
                'margin-bottom': '6vw',
                backgroundColor: '#C1C1C1',
              }"
            ></v-divider>
            <div class="bottomContainer">
              <div class="deleteIcon">
                <img
                  :src="require('../assets/delete@2x.png')"
                  width="22vw"
                  height="22vw"
                  :style="{ 'margin-top': '2.5vw' }"
                />
              </div>
              <div class="bottomFont">
                {{ $t("licence.key_delete_history") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-bottom-sheet>
    <!-- </div> -->
  </v-toolbar>
</template>

<script>
/*
Copyright 2017-2021 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
import { chatMode, liveChatStatus } from "@/store/state";
import * as animationData from "@/assets/json/bot.json";
import Lottie from "vue-lottie/src/lottie.vue";
import axios from "axios";
import Bus from "./bus.js";
// import { Encrypt, Decrpyt } from '@/utils/aesUtil';
import CryptoJS from "crypto-js";

import { update } from "../api/history.js";
import * as AWS from "aws-sdk";
// import * as AWS from 'aws-sdk/global';
import { DynamoDB } from "aws-sdk";
import {
  Config as AWSConfig,
  CognitoIdentityCredentials,
} from "aws-sdk/global";
import Kendra from "aws-sdk/clients/kendra";

export default {
  name: "toolbar-container",
  data() {
    return {
      gotop: true,
      isBottomBtnShow: true,
      browseTime: 0,
      clearTimeSet: null,
      animate: false,
      dialog: false,
      onLine: true,
      Focus: this.isTextFocus,
      sheet: false,
      defaultOptions: {
        animationData: animationData.default,
      },
      items: [
        { title: "Login", icon: "login" },
        { title: "Logout", icon: "logout" },
        { title: "Clear Chat", icon: "delete" },
        { title: "Mute", icon: "volume_up" },
        { title: "Unmute", icon: "volume_off" },
        { title: "Start Live Chat", icon: "people_alt" },
        { title: "End Live Chat", icon: "call_end" },
      ],
      shouldShowTooltip: false,
      shouldShowHelpTooltip: false,
      shouldShowMenuTooltip: false,
      prevNav: false,
      prevNavEventHandlers: {
        mouseenter: this.mouseOverPrev,
        mouseleave: this.mouseOverPrev,
        touchstart: this.mouseOverPrev,
        touchend: this.mouseOverPrev,
        touchcancel: this.mouseOverPrev,
      },
      tooltipHelpEventHandlers: {
        mouseenter: this.onHelpButtonHoverEnter,
        mouseleave: this.onHelpButtonHoverLeave,
        touchstart: this.onHelpButtonHoverEnter,
        touchend: this.onHelpButtonHoverLeave,
        touchcancel: this.onHelpButtonHoverLeave,
      },

      tooltipMenuEventHandlers: {
        mouseenter: this.onMenuButtonHoverEnter,
        mouseleave: this.onMenuButtonHoverLeave,
        touchstart: this.onMenuButtonHoverEnter,
        touchend: this.onMenuButtonHoverLeave,
        touchcancel: this.onMenuButtonHoverLeave,
      },
      tooltipEventHandlers: {
        mouseenter: this.onInputButtonHoverEnter,
        mouseleave: this.onInputButtonHoverLeave,
        touchstart: this.onInputButtonHoverEnter,
        touchend: this.onInputButtonHoverLeave,
        touchcancel: this.onInputButtonHoverLeave,
      },
      queryParams: {
        content: this.$store.state.messages,
        timeStamp: new Date().getTime(),
        timeZone: "+8",
      },
    };
  },
  props: [
    "toolbarTitle",
    "toolbarColor",
    "toolbarLogo",
    "icondotsLogo",
    "isUiMinimized",
    "userName",
    "isTextFocus",
    "token",
  ],
  components: {
    Lottie,
  },
  computed: {
    toolbarClickHandler() {
      if (this.isUiMinimized) {
        return { click: this.toggleMinimize };
      }
      return null;
    },
    toolTipMinimize() {
      return this.isUiMinimized ? "maximize" : "minimize";
    },
    isEnableLogin() {
      return this.$store.state.config.ui.enableLogin;
    },
    isForceLogin() {
      return this.$store.state.config.ui.forceLogin;
    },
    hasPrevUtterance() {
      return this.$store.state.utteranceStack.length > 1;
    },
    isLoggedIn() {
      return this.$store.state.isLoggedIn;
    },
    isSaveHistory() {
      return this.$store.state.config.ui.saveHistory;
    },
    canLiveChat() {
      return (
        this.$store.state.config.ui.enableLiveChat &&
        this.$store.state.chatMode === chatMode.BOT &&
        (this.$store.state.liveChat.status === liveChatStatus.DISCONNECTED ||
          this.$store.state.liveChat.status === liveChatStatus.ENDED)
      );
    },
    isLiveChat() {
      return (
        this.$store.state.config.ui.enableLiveChat &&
        this.$store.state.chatMode === chatMode.LIVECHAT
      );
    },
    isLocaleSelectable() {
      return this.$store.state.config.lex.v2BotLocaleId.split(",").length > 1;
    },
    restrictLocaleChanges() {
      return (
        this.$store.state.lex.isProcessing ||
        (this.$store.state.lex.sessionState &&
          this.$store.state.lex.sessionState.dialogAction &&
          this.$store.state.lex.sessionState.dialogAction.type ===
            "ElicitSlot") ||
        (this.$store.state.lex.sessionState &&
          this.$store.state.lex.sessionState.intent &&
          this.$store.state.lex.sessionState.intent.state === "InProgress")
      );
    },
    currentLocale() {
      const priorLocale = localStorage.getItem("selectedLocale");
      if (priorLocale) {
        this.setLocale(priorLocale);
      }
      return this.$store.state.config.lex.v2BotLocaleId.split(",")[0];
    },
    isLexProcessing() {
      return (
        this.$store.state.isBackProcessing || this.$store.state.lex.isProcessing
      );
    },
    shouldRenderHelpButton() {
      return !!this.$store.state.config.ui.helpIntent;
    },
    shouldRenderSfxButton() {
      return (
        this.$store.state.config.ui.enableSFX &&
        this.$store.state.config.ui.messageSentSFX &&
        this.$store.state.config.ui.messageReceivedSFX
      );
    },
    shouldRenderBackButton() {
      return this.$store.state.config.ui.backButton;
    },
    isSFXOn() {
      return this.$store.state.isSFXOn;
    },
    showToolbarMenu() {
      return (
        this.$store.state.config.lex.v2BotLocaleId.split(",").length > 1 ||
        this.$store.state.config.ui.enableLogin ||
        this.$store.state.config.ui.saveHistory ||
        this.$store.state.config.ui.shouldRenderSfxButton ||
        this.$store.state.config.ui.enableLiveChat
      );
    },
    locales() {
      const a = this.$store.state.config.lex.v2BotLocaleId.split(",");
      return a;
    },
  },
  watch: {
    isTextFocus(newval) {
      this.Focus = newval;
    },
  },
  created() {
    // this.requestLogin()
  },
  mounted() {
    // console.log('toolbarLogo--', this.toolbarLogo)

    //获取当前手机状态栏高度
    let immersed = 0;
    let ms = /Html5Plus\/.+\s\(.*(Immersed\/(\d+\.?\d*).*)\)/gi.exec(
      navigator.userAgent
    );
    if (ms && ms.length >= 3) {
      // 当前环境为沉浸式状态栏模式
      immersed = parseFloat(ms[2]); // 获取状态栏的高度
    }
    console.log("immersed0--", immersed, ms);
    window.moreOnPress = this.moreOnPress;
    window.addEventListener("online", this.update), // 网络由异常到正常时触发
      window.addEventListener("offline", this.update); //网络由正常到异常时触发
    console.log("toolbarTitle---", this.userName);
    window.addEventListener("touchmove", () => {
      this.animate = true;
      // console.log('2222')
    });
    // window.setUserInfo = this.setUserInfo;
    if (window.webkit != undefined) {
      window.webkit.messageHandlers.getUserInfo.postMessage(null);
    } else {
      feedback.getUserInfo();
    }

    this.setTime();
  },

  beforeDestroy() {
    window.removeEventListener("online", this.update);
    window.removeEventListener("offline", this.update);
    clearInterval(this.clearTimeSet);
    window.removeEventListener("touchmove", () => {
      this.animate = true;
      console.log("2222");
    });
  },
  destroyed() {
    window.localStorage.setItem("lang", "");
  },
  methods: {
    update(res) {
      console.log(res);
      this.onLine = res.type === "online";
      if (this.onLine) {
        console.log("网络正常22");
      } else {
        // toast({ text: "网络异常,请检查网络设置", time: 1000 });
        console.log("网络异常2222");
      }
    },

    moreOnPress(param) {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      // const result = JSON.parse(param);
      if (isiOS) {
        this.sendHelp();

        console.log("moreOnPress---", this.dialog);
        // this.queryParams = result.userInfo.token;
        // this.$emit('sendToken',this.queryParams)
        // window.localStorage.setItem("lang", result.userInfo.language);
      }
      // let data = {
      //   'name' : 'xiaoming'
      // };
      // return localStorage.getItem("lang");
      // console.log("333---", language);
    },
    // setUserInfo(param) {
    //   const u = navigator.userAgent;
    //   const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    //   const result = JSON.parse(param);
    //   if (isiOS) {
    //     console.log(
    //       "setUserInfo---",
    //       result,
    //       result.userInfo,
    //       result.userInfo.token
    //     );
    //     this.queryParams1 = result.userInfo.token;
    //     window.localStorage.setItem("lang", result.userInfo.language);
    //   } else {
    //     this.queryParams1 = result;
    //     console.log("setUserInfo---", param);
    //     window.localStorage.setItem("lang", result.language);
    //   }

    //   this.$i18n.locale = localStorage.getItem("lang");
    //   console.log("VueI18n---", this.$i18n.locale);
    //   // let data = {
    //   //   'name' : 'xiaoming'
    //   // };
    //   return localStorage.getItem("lang");
    //   // console.log("333---", language);
    // },

    setTime() {
      //设置定时器
      this.clearTimeSet = setInterval(() => {
        this.browseTime++;
        //  console.log(this.browseTime, "时长累计");
      }, 1000);
    },
    //加密
    encrypt(data) {
      // 十六位十六进制数作为密钥
      const SECRET_KEY = CryptoJS.enc.Utf8.parse("ts*3iuer$g9we8mi");
      // 十六位十六进制数作为密钥偏移量
      const SECRET_IV = CryptoJS.enc.Utf8.parse("");
      if (typeof data === "object") {
        try {
          // eslint-disable-next-line no-param-reassign
          data = JSON.stringify(data);
        } catch (error) {
          console.log("encrypt error:", error);
        }
      }
      const dataHex = CryptoJS.enc.Utf8.parse(data);
      const encrypted = CryptoJS.AES.encrypt(dataHex, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encrypted.toString();
    },
    //解密
    decrypt(data) {
      // 十六位十六进制数作为密钥
      const SECRET_KEY = CryptoJS.enc.Utf8.parse("ts*3iuer$g9we8mi");
      // 十六位十六进制数作为密钥偏移量
      const SECRET_IV = CryptoJS.enc.Utf8.parse("");
      const decrypt = CryptoJS.AES.decrypt(data, SECRET_KEY, {
        iv: SECRET_IV,
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      });
      const decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
      return decryptedStr.toString();
    },

    returnTop() {
      // let current = new Date().getTime();
      // let zone = new Date().getTimezoneOffset();
      // let content = this.$store.state.messages;
      // let content1 = content.slice(-30);
      // console.log('this.$store.state.messages---', content[this.$store.state.messages.length - 1].id, content1, content.length);

      // if(this.$store.state.messages.length > 2 && content[this.$store.state.messages.length - 1].id != 0) {
      //       let that = this;
      //         // console.log('查找current---',  value, value1, typeof(value1))
      //         axios
      //           .post(
      //             "https://cloud.renpho.com/RenphoHealth/robot/save",
      //           //"http://renpho.net:7009/RenphoHealth/robot/save",
      //            {
      //           content: content1,
      //           timeStamp: new Date().getTime(),
      //           timeZone: window.localStorage.getItem("timeZone"),
      //         },
      //             {
      //               headers: {
      //                 token:
      //                  // "eyJUeXBlIjoiSnd0IiwidHlwIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJleHAiOjE2NjcwMjYwODcsImlhdCI6MTY2NDQzNDA4NywidXNlcklkIjoyNDcyMTQyOTU5MDQ3Mzg3OTA4fQ.lHznijryQmuYM-blVD9bYfKjgYjXBx2-LoVK5Zp7ph8",

      //                   that.token
      //               },
      //             }
      //           )
      //           .then(function (response) {
      //             // that.devices = response.data;
      //             console.log(response);
      //             console.log("添加成功---", response);
      //           })
      //           .catch(function (error) {
      //             console.log("err", error);
      //           });
      // }

      //       let obj = {
      // 	"name": 'aa',
      // 	"age": 12
      // }
      // let enstr = Encrypt(obj, 'info')
      // console.log(enstr)
      //  console.log(Encrypt({"name":"john"},"ts*3iuer$g9we8mi"))
      //   const value = sessionStorage.getItem('store');
      //   const sessionStore = JSON.parse(value);

      //  let   value1 = sessionStore.messages.map(message => {
      //     // console.log('reloadMessages---',message)
      //     return Object.assign({}, message, {
      //       date: new Date(message.date)
      //     });
      //   });
      // let value2 = sessionStore.messages;

      if (window.webkit != undefined) {
        console.log("returnTop---");
        window.webkit.messageHandlers.browseTime.postMessage({
          duration: this.browseTime,
        });

        // window.localStorage.clear();
        window.webkit.messageHandlers.back.postMessage(null);
      } else {
        // console.log(
        //   "returnTop---",
        //   String(this.browseTime),
        //   typeof String(this.browseTime)
        // );
        feedback.browseTime(this.browseTime);
        // window.localStorage.clear();
        feedback.back();
      }

      // console.log('returnTop---')
    },
    setLocale(l) {
      const a = this.$store.state.config.lex.v2BotLocaleId.split(",");
      const revised = [];
      revised.push(l);
      a.forEach((element) => {
        if (element !== l) {
          revised.push(element);
        }
      });
      this.$store.commit("updateLocaleIds", revised.toString());
      localStorage.setItem("selectedLocale", l);
    },
    mouseOverPrev() {
      this.prevNav = !this.prevNav;
    },
    onInputButtonHoverEnter() {
      this.shouldShowTooltip = !this.isUiMinimized;
    },
    onInputButtonHoverLeave() {
      this.shouldShowTooltip = false;
    },
    onHelpButtonHoverEnter() {
      this.shouldShowHelpTooltip = true;
    },
    onHelpButtonHoverLeave() {
      this.shouldShowHelpTooltip = false;
    },
    onMenuButtonHoverEnter() {
      this.shouldShowMenuTooltip = true;
    },
    onMenuButtonHoverLeave() {
      this.shouldShowMenuTooltip = false;
    },
    onNavHoverEnter() {
      this.shouldShowNavToolTip = true;
    },
    onNavHoverLeave() {
      this.shouldShowNavToolTip = false;
    },
    toggleSFXMute() {
      this.onInputButtonHoverLeave();
      this.$store.dispatch("toggleIsSFXOn");
    },
    toggleMinimize() {
      if (this.$store.state.isRunningEmbedded) {
        this.onInputButtonHoverLeave();
        this.$emit("toggleMinimizeUi");
      }
    },
    isValidHelpContentForUse() {
      const localeId = this.$store.state.config.lex.v2BotLocaleId
        ? this.$store.state.config.lex.v2BotLocaleId
        : "en_US";
      const helpContent = this.$store.state.config.ui.helpContent;
      return (
        helpContent &&
        helpContent[localeId] &&
        ((helpContent[localeId].text &&
          helpContent[localeId].text.length > 0) ||
          (helpContent[localeId].markdown &&
            helpContent[localeId].markdown.length > 0))
      );
    },
    shouldRepeatLastMessage() {
      const localeId = this.$store.state.config.lex.v2BotLocaleId
        ? this.$store.state.config.lex.v2BotLocaleId
        : "en_US";
      const helpContent = this.$store.state.config.ui.helpContent;
      console.log("inside repeat message");
      if (
        helpContent &&
        helpContent[localeId] &&
        (helpContent[localeId].repeatLastMessage === undefined
          ? true
          : helpContent[localeId].repeatLastMessage)
      ) {
        return true;
      }
      return false;
    },
    messageForHelpContent() {
      const localeId = this.$store.state.config.lex.v2BotLocaleId
        ? this.$store.state.config.lex.v2BotLocaleId
        : "en_US";
      const helpContent = this.$store.state.config.ui.helpContent;
      let alts = {};
      if (
        helpContent[localeId].markdown &&
        helpContent[localeId].markdown.length > 0
      ) {
        alts.markdown = helpContent[localeId].markdown;
      }
      let responseCardObject = undefined;
      if (helpContent[localeId].responseCard) {
        responseCardObject = {
          version: 1,
          contentType: "application/vnd.amazonaws.card.generic",
          genericAttachments: [
            {
              title: helpContent[localeId].responseCard.title,
              subTitle: helpContent[localeId].responseCard.subTitle,
              imageUrl: helpContent[localeId].responseCard.imageUrl,
              attachmentLinkUrl:
                helpContent[localeId].responseCard.attachmentLinkUrl,
              buttons: helpContent[localeId].responseCard.buttons,
            },
          ],
        };
        alts.markdown = helpContent[localeId].markdown;
      }
      return {
        text: helpContent[localeId].text,
        type: "bot",
        dialogState: "",
        responseCard: responseCardObject,
        alts,
      };
    },
    sendHelp() {
      this.dialog = true;
      // this.$store.commit("setIsSaveHistory", true);

      // this.$store.state.messages = [];
      // if (this.isValidHelpContentForUse()) {
      //   let currentMessage = undefined;
      //   if (this.$store.state.messages.length > 0) {
      //     currentMessage =
      //       this.$store.state.messages[this.$store.state.messages.length - 1];
      //   }
      //   this.$store.dispatch("pushMessage", this.messageForHelpContent());
      //   console.log("sendHelp");
      //   this.$store.dispatch("pushChangeMsg", this.messageForHelpContent());
      //   if (currentMessage && this.shouldRepeatLastMessage()) {
      //     this.$store.dispatch("pushMessage", currentMessage);
      //     this.$store.dispatch("pushChangeMsg", currentMessage);
      //   }
      // } else {
      //   const message = {
      //     type: "human",
      //     text: this.$store.state.config.ui.helpIntent,
      //   };
      //   this.$store.dispatch("postTextMessage", message);
      // }
      // this.shouldShowHelpTooltip = false;
    },
    onPrev() {
      if (this.prevNav) {
        this.mouseOverPrev();
      }
      if (!this.$store.state.isBackProcessing) {
        this.$store.commit("popUtterance");
        const lastUtterance = this.$store.getters.lastUtterance();
        if (lastUtterance && lastUtterance.length > 0) {
          const message = {
            type: "human",
            text: lastUtterance,
          };
          this.$store.commit("toggleBackProcessing");
          this.$store.dispatch("postTextMessage", message);
        }
      }
    },
    onClickTitle() {
      Bus.$emit("clickTitle", true);
    },
    requestLogin() {
      // this.$emit("requestLogin");
      var AmazonCognitoIdentity = require("amazon-cognito-identity-js");
      // var cognitoUser = userPool.getCurrentUser();

      var authenticationData = {
        Username: "lexuser",
        Password: "gPKs2eT#6zn",
      };
      var authenticationDetails =
        new AmazonCognitoIdentity.AuthenticationDetails(authenticationData);
      var poolData = {
        UserPoolId: "us-east-1_f4Aymseho", // Your user pool id here
        ClientId: "3iu9re39amkm67ma6svoj7q4vd", // Your client id here
      };
      var userPool = new AmazonCognitoIdentity.CognitoUserPool(poolData);

      var userData = {
        Username: "lexuser",
        Pool: userPool,
      };
      var cognitoUser = new AmazonCognitoIdentity.CognitoUser(userData);
      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: function (result) {
          var accessToken = result.getAccessToken().getJwtToken();
          console.log("onSuccess---", accessToken);
          //POTENTIAL: Region needs to be set if not already set previously elsewhere.
          AWS.config.region = "us-east-1";

          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: "us-east-1:2fca637a-e90c-443e-b34c-a5cec2ffca30", // your identity pool id here
            Logins: {
              // Change the key below according to the specific region your user pool is in.
              "cognito-idp.us-east-1.amazonaws.com/us-east-1_f4Aymseho": result
                .getIdToken()
                .getJwtToken(),
            },
          });

          //refreshes credentials using AWS.CognitoIdentity.getCredentialsForIdentity()
          AWS.config.credentials.refresh((error) => {
            if (error) {
              console.error("11---", error);
            } else {
              // Instantiate aws sdk service objects now that the credentials have been updated.
              // example: var s3 = new AWS.S3();
              console.log("Successfully logged!");
            }
          });
        },

        onFailure: function (err) {
          alert(err.message || JSON.stringify(err));
        },
      });
    },
    requestLogout() {
      this.$emit("requestLogout");
    },
    requestResetHistory() {

        // this.$store.dispatch("resetHistory");

      if (this.onLine == false) {
        if (window.webkit != undefined) {
          let text = this.$t("licence.key_internet_error");
          window.webkit.messageHandlers.showToast.postMessage(text);
        } else {
          let text = this.$t("licence.key_internet_error");
          feedback.showToast(text);
        }
      }
      console.log("requestResetHistory----", this.queryParams1);
      //  this.queryParams =   Object.assign({ full: true,}, this.queryParams)
      // console.log('requestResetHistory--  after--', this.queryParams)
      console.log("requestResetHistory--  after--", this.queryParams1);
      let that = this;
      axios
        .post(
           "https://cloud.renpho.com/RenphoHealth/robot/deleteByUserId",
          // "http://renpho.net:7009/RenphoHealth/robot/deleteByUserId",
          { encryptData: "" },
          {
            headers: {
              token:
                //   "eyJUeXBlIjoiSnd0IiwidHlwIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJleHAiOjE2NjgxNTAxNDksImlhdCI6MTY2NTU1ODE0OSwidXNlcklkIjo0ODIyNjgyNTU5NjA5NTY5MTUyfQ.rC3zNo3-qaM_x3gkHek_DEnalB49srcJN2h9HoLnxu0",
                that.token,
            },
          }
        )
        .then(
          function (response) {
            console.log("response---", response.status);
            that.$store.dispatch("resetHistory");
            // that.devices = response.data;
            if (window.webkit != undefined) {
              let text = that.$t("licence.key_deleted");
              window.webkit.messageHandlers.showToast.postMessage(text);
            } else {
              let text = that.$t("licence.key_deleted");
              feedback.showToast(text);
            }
            console.log(response);
            console.log("删除成功---", response);
          },
          function (err) {
            console.log("删除失败---", err);
            if (window.webkit != undefined) {
              let text = that.$t("licence.key_internet_error");
              window.webkit.messageHandlers.showToast.postMessage(text);
            } else {
              let text = that.$t("licence.key_internet_error");
              feedback.showToast(text);
            }
          }
        );
      this.sheet = false;
      this.dialog = false;
      // if (that.token == "null") {
      //   this.$store.dispatch("resetHistory");
      // }
    },
    requestLiveChat() {
      this.$emit("requestLiveChat");
    },
    endLiveChat() {
      this.$emit("endLiveChat");
    },
    toggleIsLoggedIn() {
      this.onInputButtonHoverLeave();
      this.$emit("toggleIsLoggedIn");
    },
  },
};
</script>
<style>
::v-deep.dialog.bottom-sheet.dialog--active {
  box-shadow: none !important;
}
</style>
<style scoped>
.bottomContainer {
  display: flex;
  align-items: center;
}

.deleteIcon {
  width: 11vw;
  height: 11vw;
  border: 1px solid #c1c1c1;
  border-radius: 50%;
  margin-left: 9vw;
  margin-right: 9vw;
  /* margin-top: 1vw; */
}

.bottomFont {
  font-size: 1.1rem;
  font-weight: bold;
  color: #333333;
  text-align: -webkit-auto;
}

.toolbar-color {
  background-color: #003da5 !important;
}

.nav-buttons {
  padding: 0;
  margin-left: 8px !important;
}

.nav-button-prev {
  padding: 0;
  margin: 0;
}

.localeInfo {
  text-align: right;
  margin-right: 0;
  width: 5em !important;
}

.list .icon {
  width: 20px;
  height: 20px;
  margin-right: 8px;
}

.menu__content {
  border-radius: 4px;
}

/deep/ .menu__activator {
  position: absolute;
  top: -6vw;
}

/deep/.toolbar__content,
.toolbar__extension {
  justify-content: center;
}

.bottomsheet {
  background: #fafafa;
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
  /* height: 20px; */
  margin-top: -10px;
  box-shadow: none !important;
}

.border-top {
  width: 91px;
  height: 8px;
  border-top: solid #c1c1c1 3px;
  border-radius: 5.5px;
  top: -1vw;
  right: -37vw;
  position: relative;
}

/deep/.py-3 {
  text-align: center;
  height: 30vw;
}

.titleText {
  font-weight: bold;
  display: block;
  text-align: center;
  font-size: 4.5vw;
}

.btnContainer {
  display: flex;
  justify-content: center;
}
</style>

